import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const QAProtectedRoute = ({ children }) => {
  const { user, loading, isQA } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user && isQA()) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default QAProtectedRoute;
